import { LlmTextBlock, Text } from '@websolutespa/bom-mixer-llm';
import { Badge } from '../../components/Badge/badge';
import { MessageHead } from '../../components/MessageHead/message-head';
import style from './assistant-message.module.scss';

export type AssistantMessageProps = LlmTextBlock<'assistant'>;

export const AssistantMessage: React.FC<AssistantMessageProps> = (props) => {
  const { text, chunkIndex, index } = props;
  return (
    <div className={style.row}>
      <div className={style.left}>
        <Badge />
      </div>
      <div className={style.message}>
        <MessageHead />
        <Text body={text} chunkIndex={chunkIndex} index={index} />
      </div>
    </div>
  );
};

